/**
 * 用户区域 API
 */
import type {
  PopUserAreaListRequest,
  PopUserAreaListResponse,
} from './declare';
import { context } from '@/context';
import { Request } from '@/context/request';

const request: Request = context.request;
const host = '';

/**
 * 获取用户区域列表
 * @param params 请求参数
 * @param params.cityName 城市名称
 * @param params.orderBusinessType 业务类型（0-HP, 1-PF）
 * @returns 用户区域列表响应
 */
export const apiDispatchUserAreaPopList = async (
  params: PopUserAreaListRequest,
): Promise<PopUserAreaListResponse> => {
  const response = (await request.post<PopUserAreaListResponse>(
    host + '/api/dispatch/userArea/popList',
    params,
  )) as unknown as PopUserAreaListResponse;
  return response;
};
